import Container from '@/components/Container';
import { Typography } from '@mui/material';
import SwitchInput from '@/components/forms/SwitchInput';
import TextInput from '@/components/forms/TextInput';
import React from 'react';

interface ProducersProps {
  blockPath: string;
  tComponents: (key: string) => string;
  filterEnabled: boolean;
}

const FilterProducers: React.FC<ProducersProps> = ({ blockPath, tComponents, filterEnabled }) => (
  <Container fullWidth column right>
    <Container fullWidth>
      <Container fullWidth left>
        <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
          {tComponents('DMFilterSearch.ProducersTitleLabel')}
        </Typography>
      </Container>
      <Container fullWidth right>
        <div style={{ width: 'auto' }}>
          <SwitchInput
            path={`${blockPath}.userCanFilterProducers`}
            label={tComponents('DMFilterSearch.UserFiltrationOnWebsite')}
          />
        </div>
      </Container>
    </Container>
    <Container fullWidth>
      <TextInput path={`${blockPath}.producers`} label={tComponents('DMFilterSearch.InputLabelProducers')} />
      {filterEnabled && (
        <div style={{ width: '30%' }}>
          <TextInput
            path={`${blockPath}.producersDropDownMenuTitle`}
            label={tComponents('DMFilterSearch.ProducersDropDownMenuTitleLabel')}
          />
        </div>
      )}
    </Container>
  </Container>
);

export default FilterProducers;
